import gql from 'graphql-tag';
import { compose } from 'ramda';

import { selectParams } from '#src/store/location/selectors';
import { toNotFound } from '#src/store/location/actions';
import { setRoutinesCampaign } from '#src/store/content/actions';
import { selectTimeZone } from '#src/store/intl/selectors';
import { logger } from '#src/lib/logger';
import { baseImageGraphqlFields } from '#src/lib/wb-asset/image-graphql-fields';

const query = gql`
  query Games($label: String!, $timeZone: String!) {
    joinableGamesByType(
      falkor: { search: { label: $label }, searchBoolean: and }
      timeZone: $timeZone
    ) {
      edges {
        ... on FalkorGame {
          id
          description
          dashboardHeadline
          endDate
          hosts {
            id
            displayName
            isOfficialCoach
            avatarV2 {
              type
              value
            }
          }
          image {
            ${baseImageGraphqlFields}
          }
          labels {
            id
            name
          }
          startDate
          title
          wideImage {
            ${baseImageGraphqlFields}
          }
        }
      }
    }
    labels(search: { name: $label }) {
      edges {
        id
        name
        image {
          ${baseImageGraphqlFields}
        }
      }
    }
  }
`;

// TODO: pull this from RemoteConfig
const remoteConfigData = {
  huberman: {
    headerHighlight: '16 out of 200 spots remaining',
    joinButtonLabel: 'Join the Huberman Challenge',
    component: 'HubermanCampaignDetails',
  },
  '5k-steps-a-day': {
    headerHighlight: '16 out of 200 spots remaining',
    joinButtonLabel: 'Join the 5K Steps a Day Challenge',
    component: 'HubermanCampaignDetails',
  },
};

export const path = '/routines/:campaignName';
export const component = 'RoutinesGameLanding';
export const thunk =
  ({ graphqlClient }) =>
  async (dispatch, getState) => {
    const state = getState();
    const timeZone = selectTimeZone(state);
    const { campaignName } = selectParams(state);

    const labelName = `routines-${campaignName}`;
    const { data } = await graphqlClient.query({
      query,
      fetchPolicy: 'network-only',
      variables: { label: labelName, timeZone },
    });

    const games = data?.joinableGamesByType?.edges || [];
    if (games.length === 0) {
      logger.error(`[routines-campaign] didn't find game: ${campaignName}`);
      return dispatch(toNotFound());
    }

    const label = data?.labels?.edges?.[0];
    if (!label) {
      logger.error(`[routines-campaign] didn't find label: ${campaignName}`);
      return dispatch(toNotFound());
    }

    // TODO: pull this from RemoteConfig
    const config = remoteConfigData[campaignName];
    if (!config) {
      logger.error(
        `[routines-campaign] didn't find remoteConfigData: ${campaignName}`
      );
      return dispatch(toNotFound());
    }

    const campaign = {
      games,
      label,
      ...config,
    };

    compose(dispatch, setRoutinesCampaign)(campaign);
  };
